<template>
    <section class="tabs-section">
        <div class="container">
            <div class="row gx-2">
                <div class="col-lg-8">
                    <div class="tabs">
                        <div class="tabs-heading js-tabs-heading">
                            <div class="item"
                                 @click="isActive = true"
                                 :class="{ 'active': isActive }"
                            >
                                {{ descriptionTrans }}
                            </div>
                            <div class="item"
                                 @click="isActive = false"
                                 :class="{ 'active': !isActive }"
                                 v-if="productAttachments.length > 0"
                            >
                                {{ downloadsTrans }}
                            </div>
                        </div>
                        <div class="tabs-content js-tab-content">
                            <div class="tab"
                                 :class="{ 'active': isActive }"
                                 v-html="productDescription"
                            >
                            </div>
                            <div class="tab"
                                 :class="{ 'active': !isActive }"
                            >
                                <div class="downloads">
                                    <a  v-for="(attachment, index) in productAttachments"
                                        :key="index"
                                        :href="attachment[0]"
                                        class="with--icon"
                                    >
                                        <span v-html="getIcon(attachment[1])"></span>
                                        {{ attachment[1] }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <specifications :specifications-data="specifications"></specifications>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Specifications from './Specifications';

    export default {
        props: {
            descriptionTrans: {
                required: true,
                type: String
            },
            downloadsTrans: {
                required: true,
                type: String
            },
            productDescription: {
                required: false,
                type: String
            },
            productAttachments: {
                required: false,
                type: Array
            },
            specifications: {
                required: false,
                type: Array
            }
        },

        data() {
            return {
                isActive: true
            }
        },

        methods: {
            getIcon(extension) {
                let ext = extension.substr(extension.lastIndexOf('.') + 1);

                switch ( ext ) {
                    case 'pdf': return '<i class="fas fa-file-pdf">';
                    case 'csv': return '<i class="fas fa-file-csv">';
                    case 'excel': return '<i class="fas fa-file-excel">';
                    case 'doc': return '<i class="fas fa-file-word">';
                    default: return '<i class="fas fa-file">';
                }
            }
        },

        components: {
            Specifications
        }
    }
</script>
